import React, { ReactNode, useEffect, useState } from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, Button, Grid } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import UserInfos from '../../components/UserInfo/UserInfos';
import AccordionCustom from '../../components/AccordionCustom/AccordionCustom';
import { useTranslationContext } from '../../hooks/translations/translationsProvider';
import { useUserContext } from '../../hooks/auth/UserProvider';
import { useNavigate } from 'react-router-dom';
import { checkIfUserIsCompanyOrAssociation, checkUserEnabled } from '../../helpers/authorizedUser';
import ChangePassword from '../../components/ChangePassword/ChangePassword';
import MarketList from '../../components/Markets/MarketList';
import { GREEN_MAIN } from '../../theme/colors';

interface DefaultAssocAndCompanyPageProps{
    titleType?: number;
    children: ReactNode;
}

const DefaultCompanyPage: React.FC<DefaultAssocAndCompanyPageProps> = ({children, titleType}) => {
  const {t} = useTranslationContext();

  // utente autorizzato
  const {user, auth} = useUserContext();
  const navigate = useNavigate();
  const {checkIsAuth} = useUserContext();
  const [title, setTitle] = useState<string>("");
  const [subtitle, setSubTitle] = useState<string|null>(null);

  // verifica se è una company SOLO COMPANY
  useEffect(()=>{
      if (!auth.isLoading) {
          if (auth.isAuthenticated) {
              if(user){
                  
                  const companyRoles = ["Company"];

                  const hasRole = (userRoles: string | string[] | undefined | null, rolesToCheck: string[]): boolean => {
                      if (Array.isArray(userRoles)) {
                          return userRoles.some((role: string) => rolesToCheck.includes(role));
                      } else if (typeof userRoles === "string") {
                          return rolesToCheck.includes(userRoles);
                      }
                      return false; // Se userRoles è undefined o null
                  };
                  
                  // Company
                  if (!hasRole(user.role, companyRoles)) {
                    navigate("/404")
                  }
              }
          }
      }
  },[auth.isAuthenticated, auth.isLoading, user])

  useEffect(()=>{
    if(titleType !== null && titleType !== undefined){
      switch(titleType){
        case 0:
          setTitle("Gestisci le attività economiche");
          setSubTitle(null);
          break;
        default:
          setTitle("");
          setSubTitle(null);
          break;
      }
    }else{
      setTitle("");
      setSubTitle(null);
    }
  },[children])

  return (
    <>
      <Box sx={{
        width:'100%', 
        display:'flex', 
        flexDirection:'column',
        color: GREEN_MAIN,
        fontFamily:'poppins'
      }}>
        {
        auth.isAuthenticated && 
        <>
            {/* Main title */}
            <Grid container justifyContent='center'>
              <Grid item xs={12} sm={9} md={6}>
                <Typography
                    variant="h3"
                    component="h1"
                    gutterBottom
                    sx={{
                        mb: 0,
                        mt: 0,
                        fontWeight: "bold",
                    }}
                >
                    {t(title)}
                </Typography>
                {subtitle && <Typography
                    variant="h5"
                    gutterBottom
                    sx={{
                        mb: 0,
                        mt: 0,
                    }}
                >
                    {t(subtitle)}
                </Typography>}
              </Grid>
            </Grid>
            {children}
          </>
        }
        
      </Box>
    </>
  );
};

export default DefaultCompanyPage;
